export default "__VITE_ASSET__DiW7gJjS__"